import React from 'react'
import { Link } from 'react-router-dom'
import clientList from '../../data/clientList.json'

const Clients = ({ data }) => {

  return (
    <>
      <p>
        <a href="https://twitch.tv/kidakupo"> Twitch </a>
        <a href="https://shop.kidakupo.com"> Shop </a>
      </p>
      <p>
        {
          clientList.grouped.map((group, index) => {
            return <div><span className="highlight" key={index}>{`${group.displayName}.`}</span>
              {
                group.clients.map((client, index) => {
                  return <Link to={client.name} key={index}>{` ${client.displayName}`}</Link>
                })
              }
            </div>
          })
        }
      </p>
      <p>
        {
          clientList.ungrouped.map((client, index) => {
            return <Link to={client.name} key={index}>{` ${client.displayName}`}{' '}</Link>
          })
        }
        <Link to="/"> (C) Kidakupo. All rights reserved. </Link>
      </p>
    </>
  )
}

export default Clients